import React, { useEffect } from 'react';
import { translations } from '../translations';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import WaitlistForm from '../components/WaitlistForm';

function ComingSoon({ language = 'en' }) {
  const t = translations[language];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-blue-50 px-4">
      <div className="max-w-2xl w-full text-center">
        <Link 
          to="/" 
          className="inline-flex items-center text-[#3498DB] hover:text-[#2980B9] mb-8 group"
        >
          <ArrowLeft className="w-5 h-5 mr-2 transition-transform group-hover:-translate-x-1" />
          {t.comingSoon.backToHome}
        </Link>
        
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {t.comingSoon.title}
        </h1>
        
        <p className="text-xl text-gray-600 mb-12 max-w-xl mx-auto">
          {t.comingSoon.description}
        </p>

        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-gray-100">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            {t.comingSoon.waitlistTitle}
          </h2>
          <p className="text-gray-600 mb-6">
            {t.comingSoon.waitlistDescription}
          </p>
          <WaitlistForm language={language} />
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-lg border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
              <svg className="w-6 h-6 text-[#3498DB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {t.comingSoon.features.speed.title}
            </h3>
            <p className="text-gray-600">
              {t.comingSoon.features.speed.description}
            </p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-lg border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
              <svg className="w-6 h-6 text-[#3498DB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {t.comingSoon.features.security.title}
            </h3>
            <p className="text-gray-600">
              {t.comingSoon.features.security.description}
            </p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-lg border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
              <svg className="w-6 h-6 text-[#3498DB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {t.comingSoon.features.analytics.title}
            </h3>
            <p className="text-gray-600">
              {t.comingSoon.features.analytics.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon; 